// Copyright Genesis Global Solutions

//import { Injectable } from '@angular/core';

declare var Genesis;

let supportsWebSockets = 'WebSocket' in window || 'MozWebSocket' in window;

export interface IDtaService {
  // CREASTUDIO-548: we now need to "hide" the login operation behind this interface
  // as one of the concrete implementations (DtaSwitcherService) needs to add additional logic on top of it
  // I found this to be a bit of abstraction leaking but I don't have any alternative at the moment
  login(loginOptions, https);

  getDta();
}

//@Injectable()
export class DtaService {
  constructor(
    endpoint: string,
    private httpEndpoint: string) {

    if (!supportsWebSockets) {
      this._Dta = this.createHttpConnection();

    } else {
      let wsEndpoint = `ws://${endpoint}`;
      let testConnection = new WebSocket(wsEndpoint);
      testConnection.onerror = (ev) => {
        console.log(`Cannot establish connection to ${wsEndpoint} using ws, falling back to http`);

        this._Dta = this.createHttpConnection();
      }

      testConnection.onopen = (ev) => {
        console.log(`Connection to ${wsEndpoint} using ws is supported!`);

        this._Dta = new Genesis.DTA();
      }
    }
  }

  login(loginOptions, https) {
    return this._Dta.login(loginOptions, false, https);
  }

  getDta() {
    console.log("Trying to access _Dta");

    let tryAccessDta = (resolve, reject) => {
      if (this._Dta) {
        resolve(this._Dta);
      } else {
        setTimeout(() => {
          tryAccessDta(resolve, reject);
        }, 100);
      }
    }

    return new Promise((resolve, reject) => {
      tryAccessDta(resolve, reject);
    });
  }

  private createHttpConnection() {
    return new Genesis.DTA(null, {
      http: true,
      endpoint: `http://${this.httpEndpoint}`,
      version: "sm",
      defaultPollingInterval: 60000
    });
  }

  private _Dta;
}
